// extracted by mini-css-extract-plugin
module.exports = {"Personality":"personality-print_Personality__pxQMT","Personality__h3":"personality-print_Personality__h3__12nNX","Personality__table":"personality-print_Personality__table__145Eu"};